import React, { useId } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
// styles
import './styles.if.scss'

const InputForm = (props) => {
  const inputId = useId()
  const { labelText = null, type, placeholder, isError, errorMessage, register } = props

  return (
    <div className={clsx('inputForm', isError && 'errorInput')}>
      {labelText && <label htmlFor={`inputForm_${inputId}`}>{labelText}</label>}
      <input type={type} placeholder={placeholder} {...register} />
      {isError && <span className="errorMessage">{errorMessage}</span>}
    </div>
  )
}

InputForm.propTypes = {
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  register: PropTypes.any,
}

export default InputForm
